<template>
  <v-app-bar app color="white">
    <!--<v-img
    class="mx-2"
    max-height="40"
    max-width="40"
    src="../assets/TU-Signet.jpg"
    contain
    ></v-img>
    <v-img
    class="mx-2"
    max-height="40"
    max-width="40"
    src="../assets/UA.png"
    contain
    ></v-img>-->
    <v-toolbar-title>
      <router-link to="/" tag="span" style="cursor: pointer">
        <span class="primary--text headline">{{ appTitle }}</span>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-appbar-items class="hidden-xs-only">
      <v-btn class="ma-2" tile outlined color="primary" :to="{ name: 'create'}">
        <v-icon left>mdi-subway-variant</v-icon> Create Map
      </v-btn><!--
      <v-btn class="ma-2" tile outlined color="primary" :to="{ name: 'data'}">
        <v-icon left>mdi-database</v-icon> View Data
      </v-btn>-->
      <v-btn class="ma-2" tile outlined color="primary" :to="{ name: 'maps'}">
        <v-icon left>mdi-map</v-icon> View Maps
      </v-btn>
    </v-appbar-items>
    <v-spacer></v-spacer>

    <v-appbar-items class="hidden-sm-and-down">
      <v-btn class="ma-2" tile outlined color="primary" :to="{ name: 'help'}">
        <v-icon left>mdi-help-circle-outline</v-icon> Help
      </v-btn>
      <v-btn class="ma-2" tile outlined color="primary" :to="{ name: 'about'}">
        <v-icon left>mdi-information-outline</v-icon> About
      </v-btn>
    </v-appbar-items>

    <v-appbar-items  class="hidden-md-and-up">
    <v-menu left offset-y offset-x>
        <template v-slot:activator="{ on }" class="hidden-md-and-up">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item-group v-model="item" color="primary">
          <v-list-item :to="{ name: 'create'}" class="hidden-sm-and-up">
            <v-list-item-icon>
              <v-icon color="primary">mdi-subway-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title color="primary">Create Map</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!--<v-list-item :to="{ name: 'data'}" class="hidden-sm-and-up">
            <v-list-item-icon>
              <v-icon color="primary">mdi-database</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>View Data</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->

          <v-list-item :to="{ name: 'maps'}" class="hidden-sm-and-up">
            <v-list-item-icon>
              <v-icon color="primary">mdi-map</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>View Maps</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'help'}" class="hidden-md-and-up">
            <v-list-item-icon>
              <v-icon color="primary">mdi-help-circle-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Help</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'about'}" class="hidden-md-and-up">
            <v-list-item-icon>
              <v-icon color="primary">mdi-information-outline</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>About</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        </v-list>
    </v-menu>
    </v-appbar-items>
  </v-app-bar>
</template>
<script>
export default {
  name: 'Navbar',
  data () {
    return {
      appTitle: 'Metro Sets'
    }
  }
}
</script>
